import { render, staticRenderFns } from "./TournamentEdit.vue?vue&type=template&id=cdc2da34&scoped=true"
import script from "./TournamentEdit.vue?vue&type=script&lang=js"
export * from "./TournamentEdit.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TournamentEdit.vue?vue&type=style&index=1&id=cdc2da34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc2da34",
  null
  
)

export default component.exports